import { useLocation, useSearch } from "wouter-preact";
import { signInDestination } from "../features/auth/signInDestination";
import { OnboardingFlow } from "../features/onboarding/OnboardingFlow";
import { useSiteConfig } from "../features/tenant/SiteConfigContext";
import { routes } from "../lib/route";

export function SignInPage() {
  const site = useSiteConfig();
  const search = useSearch();
  return (
    <SignIn key={`${site.tenantId}:${search}`} providerName={site.displayName} search={search} />
  );
}

function SignIn({ providerName, search }: { providerName: string; search: string }) {
  const [, navigate] = useLocation();
  const destination = signInDestination.fromSearch(search) ?? routes.portal.overview();
  return (
    <section class="sign-in-page" aria-label="Account sign in">
      <div class="search-card">
        <OnboardingFlow
          providerName={providerName}
          onComplete={() => navigate(destination, { replace: true })}
        />
      </div>
    </section>
  );
}
